import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Product Name',
    value: 'categoryName',
  },
  {
    label: 'Raw material Category',
    value: 'categoryName',
  },
  {
    label: 'Balance',
    value: 'Balance',
  },
]

export const header_one = [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'actualCollectionDate',
  },
  {
    label: 'Supplier name',
    value: 'supplier',
  },
  {
    label: 'Declaration Number',
    value: 'id',
  },
  {
    label: 'Site Name',
    value: 'siteName',
  },
  {
    label: 'Country',
    value: 'country',
  },
  {
    label: 'Quantity',
    value: 'quantity',
  },
]
export const header_two = [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'actualSupplyDate',
  },
  {
    label: 'Buyer Name',
    value: 'buyerName',
    // value: 'siteName',
  },
  {
    label: 'Declaration Number',
    value: 'id',
  },
  {
    label: 'Site Name',
    value: 'siteName',
  },
  {
    label: 'Country',
    value: 'country',
  },
  {
    label: 'Quantity',
    value: 'quantity',
  },
]

export const header_three = [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'actualProcessDate',
  },
  {
    label: 'Process name',
    value: 'processName',
  },
  {
    label: 'Declaration Number',
    value: 'id',
  },
  {
    label: 'Site Name',
    value: 'siteName',
  },
  {
    label: 'Country',
    value: 'country',
  },
  {
    label: 'Quantity',
    value: 'quantity',
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)
const roleColumns_new: ReadonlyArray<Column<any>> = columnGenerators(header_one)

export { roleColumns, roleColumns_new }
